import React from "react";
import { Calendar, User } from "lucide-react";
import ImageNotFound from "../images/Image_not_available.png";
import formatDate from "../utils/formatDate";
import badgeStyles from "../utils/badgeStyles";
import "./NewsCrawler.css"; // Import the CSS file

// Card component
const NewsCard = ({ article, setSelectedArticle }) => {
  // Get the correct badge class using our updated badgeStyles helper
  const getTopicBadgeClass = (topic) => {
    if (!topic) return "news-card__badge news-card__badge--topic-default";
    return (
      badgeStyles.newsCard.topic[topic] ||
      "news-card__badge news-card__badge--topic-default"
    );
  };

  const getSentimentBadgeClass = (sentiment) => {
    if (!sentiment)
      return "news-card__badge news-card__badge--sentiment-default";
    return (
      badgeStyles.newsCard.sentiment[sentiment] ||
      "news-card__badge news-card__badge--sentiment-default"
    );
  };

  return (
    <div className="news-card" onClick={() => setSelectedArticle(article)}>
      <div className="news-card__image-container">
        <img
          src={article.imageLink || ImageNotFound}
          alt={article.title}
          className="news-card__image"
        />
        <div className="news-card__badge-container">
          <div className="news-card__badges">
            {article.topic && (
              <span className={getTopicBadgeClass(article.topic)}>
                {article.topic}
              </span>
            )}
            {article.sentiment && (
              <span className={getSentimentBadgeClass(article.sentiment)}>
                {article.sentiment}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="news-card__content">
        <h2 className="news-card__title">{article.title}</h2>
        <p className="news-card__summary">{article.summary}</p>
        <div className="news-card__footer">
          <div className="news-card__meta">
            <Calendar size={14} className="news-card__meta-icon" />
            {formatDate(article.datePublished)}
          </div>
          <div className="news-card__meta">
            <User size={14} className="news-card__meta-icon" />
            {article.author || "Unknown"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
